module.exports = {"id":"199416","name":"Ibai Gómez","rating":"76","photo":"./data/images/photos/3/199416.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IbaiGomez0.json
// module id = 1764
// module chunks = 0